"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedGuestRoster =
/*#__PURE__*/
function (_pb_1$GuestRoster) {
  _inherits(ExtendedGuestRoster, _pb_1$GuestRoster);

  function ExtendedGuestRoster(properties) {
    var _this;

    _classCallCheck(this, ExtendedGuestRoster);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedGuestRoster).call(this, properties));
    _this.type = ExtendedGuestRoster.type;
    return _this;
  }

  _createClass(ExtendedGuestRoster, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.guest).concat(ExtendedGuestRoster.context);
      var mqttMessage = new paho_mqtt_1.Message(ExtendedGuestRoster.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      mqttMessage.retained = true;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedGuestRoster(pb_1.GuestRoster.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedGuestRoster;
}(pb_1.GuestRoster);

ExtendedGuestRoster.type = "GuestRoster";
ExtendedGuestRoster.context = "/roster";
exports.GuestRoster = ExtendedGuestRoster;